import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { css } from '@emotion/react';

export const StyledDetailsSectionTextSecondary = styled(Typography)`
  color: #333333;
  font-weight: 700;
  font-size: 14px;
  ${(props) =>
    props.sx &&
    css`
      ${props.sx}
    `}
`;
